import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'When a customer switches into any asset mode',
  name: 'asset_mode_switched',
  params: [
    {
      description: 'The asset mode the user switched to',
      name: 'asset_mode',
      required: true,
      type: 'enum',
      values: ['edit', 'view', 'presentation', 'comment'],
    },
    {
      description: 'The category of the asset',
      name: 'category',
      required: true,
      type: 'enum',
      values: ['asset_details'],
    },
  ],
};

export default META;
